module.exports = __webpack_public_path__ + "media/images/img/seikousya/ntt-9f64fa3f468bd0906c86cb77d3a7a37e.png";